import { Warning } from '@mui/icons-material';
import { Button } from '@mui/material';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useHandleChangeSizeNavigation from 'Global/Hooks/useHandleChangeSizeNavigation';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
const NotFoundPage = () => {
  const block404 = useHandleChangeSizeNavigation();

  const languageArray =
    useContext(GlobalContext)?.LanguageArray;
  const navigate = useContext(GlobalContext)?.navigate;
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    if (removed)
      if (!Cookies.get('user')) {
        navigate('/');
      } else {
        navigate('/main');
      }
  }, [removed]);

  return (
    <React.Fragment>
      {block404 ? (
        <></>
      ) : (
        <>
          <div
            style={{
              width: '100%',
              height: '100vh',
              background: 'rgb(13, 17, 23)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Warning
              sx={{ color: 'orange', fontSize: '3em' }}
            />
            <code
              style={{
                textAlign: 'center',
                color: 'white',
                width: '100%',
                fontSize: '8em',
              }}
            >
              404
            </code>
            <blockquote
              style={{
                color: 'white',
              }}
            >
              {FindLangKey(
                'general-public-not-found-page',
                languageArray
              )}
            </blockquote>
            <Button
              sx={{ mt: '2em' }}
              variant="outlined"
              onClick={() => {
                setRemoved((prev) => !prev);
              }}
            >
              {FindLangKey(
                'general-public-not-found-return',
                languageArray
              )}
            </Button>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default NotFoundPage;
